// material-ui
import { Button, Grid, Stack, Typography } from '@mui/material';

// project imports
import AuthWrapper1 from './AuthWrapper1';

// assets
import fondoDerecho from 'assets/images/fondo_derecho.png';
import Frustlogo from 'assets/images/LogoFrust.png';
import fondo_celebracion from 'assets/images/fonde_celebracion.png';
// ================================|| AUTH3 - LOGIN ||================================ //

const AwsConnectSucess = () => {
    const openInNewTab = (url: string) => {
        window.open(url, '_blank', 'noreferrer');
    };
    const openCal = () => {
        openInNewTab('https://zcal.co/i/veixFr52');
    };
    return (
        <AuthWrapper1>
            <Grid
                container
                direction="column"
                justifyContent="flex-end"
                sx={{
                    minHeight: '100vh',
                    backgroundImage: `url(${fondoDerecho});`
                }}
            >
                <Grid item xs={12} px={2}>
                    <img src={Frustlogo} alt="Frust Logo" height={'20px'} />
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid
                            item
                            sx={{
                                m: { xs: 1, sm: 3 },
                                mb: 0,
                                backgroundImage: `url(${fondo_celebracion});`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                background: 'center center cover;'
                            }}
                            bgcolor={'#FFF'}
                            maxWidth={500}
                        >
                            <Grid container spacing={1} alignItems="center" justifyContent="center" px={6} py={6}>
                                <Grid item xs={12}>
                                    <Typography
                                        color={'#000'}
                                        fontSize={26}
                                        fontFamily={'Chivo'}
                                        fontWeight={600}
                                        maxWidth={345}
                                        pb={15}
                                        pt={4}
                                    >
                                        ¡Ya estamos procesando tu información! Dentro de los próximos días enviaremos a tu correo
                                        electrónico las acciones propuestas para que pagues menos en AWS.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography color={'#000'} fontSize={16} fontFamily={'Chivo'} fontWeight={700} textAlign={'right'}>
                                        ¿Quieres revisar tus resultados más rápido?
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography color={'#000'} fontSize={16} fontFamily={'Chivo'} fontWeight={400} textAlign={'right'}>
                                        Agenda una llamada
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Stack direction="row" justifyContent="end" mt={2}>
                                        <Button
                                            onClick={openCal}
                                            sx={{
                                                backgroundColor: '#FFFFFF',
                                                color: '#000000',
                                                borderColor: '#000000',
                                                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
                                            }}
                                        >
                                            Agendar demo
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
};

export default AwsConnectSucess;
